function hasPermission(authUser, permission) {
  return authUser && authUser.behaviors && authUser.behaviors.includes(permission);
}

export default {
  methods: {
    hasPermission,
  },
};